import React, { useState } from "react";
import loadable from "@loadable/component";
import { useParams, useSearchParams } from "react-router-dom";
import usePaginationState from "../../customHooks/usePaginationHook";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import moment from "moment";

const StockDetailComponent = loadable(
  () => import("../../components/Stock/StockDetail")
);

type Props = {};

const StockDetail = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dateStart = startDate
    ? moment(startDate).startOf("day").format("yyyy-MM-DDTHH:mm:ss")
    : null;
  const dateEnd = endDate
    ? moment(endDate).endOf("day").format("yyyy-MM-DDTHH:mm:ss")
    : null;
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const { data: stockHistory, isPending: stockLoading } = useGetHook({
    queryKey: [
      `stock-history-${pageSize}-${offset}-${searchQuery}-${id}-${dateStart}- ${dateEnd}`,
    ],
    url: `${APIS.STOCK_HISTORY}`,
    params: {
      product: id,
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
      ...(dateStart &&
        dateEnd && { created__range: `${dateStart}, ${dateEnd}` }),
    },
  });
  return (
    <>
      <StockDetailComponent
        stockHistory={stockHistory}
        stockLoading={stockLoading}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </>
  );
};

export default StockDetail;
